module.exports = __webpack_public_path__ + "img/changeLogo.9c4bcfaf.png";